export { KnowledgeBase } from './KnowledgeBase';
